import { render } from "./AppFooterNonHome.vue?vue&type=template&id=454eb4c5"
import script from "./AppFooterNonHome.vue?vue&type=script&lang=js"
export * from "./AppFooterNonHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__